import React from 'react';
import PropTypes from 'prop-types';
import {v4 as uuid} from 'uuid';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import _ from 'lodash';

import { SUBTABS, TRY_STEPS } from './ConstPaths';
import { getActivityLabelForValue, isBuiltInActivity, TEST_DRIVE_ACTIVITIES,
  DEFAULT_TEXTS_IN_TEST, DEFAULT_TEXT_LANGUAGE, DEFAULT_TEXT_UNIT, 
  DEFAULT_TARGETS_IN_TEST, DEFAULT_TARGET_SIZE, DEFAULT_TARGET_TYPE,
  DEFAULT_HITS_IN_TEST
} from './ConstForTestDriveSection';
import TestDriveTryActivity from './TestDriveTryActivity';
import TestDriveTryStart from './TestDriveTryStart';
import TestDriveTryDo from './TestDriveTryDo';
import TestDriveTryUpdate from './TestDriveTryUpdate';
import TestDriveTryAnother from './TestDriveTryAnother';

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  provider: PropTypes.object,
  isLowTechPath: PropTypes.bool,
  activeTestDrive: PropTypes.object,
  activeTestDriveActivityId: PropTypes.string,
  updateActiveTestDriveId: PropTypes.func.isRequired,
  updateSession: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  provider: null,
  isLowTechPath: false,
  activeTestDrive: {},
  activeTestDriveActivityId:'',
};

//Manage the wizard form for the Test-drive / Try sub-tab
//Initialize the forms with props and manage those as local state.
// Following pattern described in https://goshacmd.com/wizard-form-collect-info/

//the steps of the wizard form:
const steps = TRY_STEPS;

const BASE_URL = SUBTABS.TRY + "/";
const NEXT_SECTION = SUBTABS.RATE;

class TestDriveTry extends React.Component {
  constructor(props) {
    super(props);
    console.log("running the TestDriveTry constructor, which initializes state");
    var runningRemoteTestDrive = window.testDriveClinicianId && window.testDriveTaskId;
    var runningRemotePractice = !!window.practiceBuiltInActivityType;
    //manage the incoming props  - including those that can be changed in this section - as local state
    this.state = {
      prevActiveTestDrive: this.props.activeTestDrive, //for getDerivedStateFromProps
      activeTestDrive: this.props.activeTestDrive,

      //array of the Activities performed in the test drive
      activeTestDriveActivities: this.props.activeTestDrive.activeTestDriveActivities,

      //******DERIVED from activeTestDrive. Need to initialize these because we are using them FLAT in local state */
      // //in /start form
      activeTestDriveCurrentActivityNumTexts: this.props.activeTestDrive.activeTestDriveCurrentActivityNumTexts,
      activeTestDriveCurrentActivityLanguage: this.props.activeTestDrive.activeTestDriveCurrentActivityLanguage,
      activeTestDriveCurrentActivityTextUnit: this.props.activeTestDrive.activeTestDriveCurrentActivityTextUnit,
      activeTestDriveCurrentActivityNumTargets: this.props.activeTestDrive.activeTestDriveCurrentActivityNumTargets,
      activeTestDriveCurrentActivityTargetSize: this.props.activeTestDrive.activeTestDriveCurrentActivityTargetSize,
      activeTestDriveCurrentActivityTargetType: this.props.activeTestDrive.activeTestDriveCurrentActivityTargetType,
      activeTestDriveCurrentActivityNumPrompts: this.props.activeTestDrive.activeTestDriveCurrentActivityNumPrompts,
      activeTestDriveCurrentActivityPromptType: this.props.activeTestDrive.activeTestDriveCurrentActivityPromptType,
      activeTestDriveCurrentActivityComplete: this.props.activeTestDrive.activeTestDriveCurrentActivityComplete,

      //local state just to govern the TestDrive section (not saved to App and database)
      //true if builtInActivity is complete -- if false, show the test. if true, show the results.
      // builtInActivityComplete: Boolean(this.props.activeTestDrive.activeTestDriveCurrentActivityDuration),
      //'true' if you choose to do another activity in the test drive
      activeTestDriveActivityId: this.props.activeTestDriveActivityId,
      provider: this.props.provider,
      runningRemoteTestDrive: runningRemoteTestDrive,
      runningRemotePractice: runningRemotePractice,
      doAnotherActivity: '',
      showSettings: true,
      runningPractice: runningRemotePractice,
      runOnSameComputer: 'true', //a STRING. 'false' if you want to run the activity on a different device (like the client's own device)
    };

    this.state.testDriveUrl = this.getRemoteUrl();

    //save activity data to local state
    this.saveActivityResultsToLocalState = this.saveActivityResultsToLocalState.bind(this);
    this.setActivityFinished = this.setActivityFinished.bind(this);
    this.setShowSettings = this.setShowSettings.bind(this);

    //these methods save local state data to the global Session data
    this.saveActiveTestDriveCurrentActivityToSession = this.saveActiveTestDriveCurrentActivityToSession.bind(this);
    this.saveActivitySettingsToSession = this.saveActivitySettingsToSession.bind(this);
    this.saveActivityResultsToSession = this.saveActivityResultsToSession.bind(this);
    this.saveSetupInfoToSession = this.saveSetupInfoToSession.bind(this);

    //this governs where to go when you hit Continue
    this.onContinue = this.onContinue.bind(this);
  }

  //https://reactjs.org/docs/react-component.html
  //getDerivedStateFromProps is invoked right before calling the render method, both on the initial mount and on subsequent updates. 
  //It should return an object to update the state, or null to update nothing.
  //Enables a component to update its internal state as the result of changes in props.
  //Allows the /try/update-setup component to stay in synch with any setup info changes that happen in the /setup/info form.
  //When you move from /setup/info *directly* to the /try section, TestDriveTry is actually constructed BEFORE
  //TestDriveSetupInfo unmounts.  So if you jump directly to the /try section,
  //the data saved on the unmount won't be immediately available to TestDriveTry.
  //Once TestDriveSetupInfo unmounts, its data are saved and passed in as changed props to TestDriveTry, 
  //and then this method updates the state accordingly.
  //Used both here and in TestDriveSetup to allo editing setup info from both sections.
  //See TestDriveSetup comments for more details.
  //TODO this is a bit of a kludge - may want to revisit
  static getDerivedStateFromProps(props, state) {
    // console.log("called getDerivedStateFromProps, props: " + JSON.stringify(props) + ", state: " + JSON.stringify(state));
    if (!_.isEqual(props.activeTestDrive, state.prevActiveTestDrive)){
        return {
          prevActiveTestDrive: {...props.activeTestDrive},
          activeTestDrive: {...props.activeTestDrive},
        };
      }
    return null;
  }

  //Get the current step from the URL
  getCurrentStep(){
    //e.g. URL of '/gather-info/contexts/intro' would have step of 'intro'
    //props.match: {"step":"intro"}
    const stepParam = this.props.match.params.step;
    if(stepParam){
      return(stepParam);
    }
    else{
      return(steps.ACTIVITY);
    }
  }

  getRemoteUrl(){
    if(this.state.runningPractice){
      switch(this.state.activeTestDrive.activeTestDriveCurrentActivity){
        case TEST_DRIVE_ACTIVITIES.TEXT_ENTRY_BASIC:
          return (
            `${window.location.origin
            }/test-drive/try/do/text-entry?activityType=${
            this.state.activeTestDrive.activeTestDriveCurrentActivity
            }&language=${this.state.activeTestDriveCurrentActivityLanguage ? this.state.activeTestDriveCurrentActivityLanguage : DEFAULT_TEXT_LANGUAGE
            }&textUnit=${this.state.activeTestDriveCurrentActivityTextUnit  ? this.state.activeTestDriveCurrentActivityTextUnit : DEFAULT_TEXT_UNIT}`
          );
        case TEST_DRIVE_ACTIVITIES.POINTING_BASIC:
          return (
            `${window.location.origin
            }/test-drive/try/do/text-entry?activityType=${
            this.state.activeTestDrive.activeTestDriveCurrentActivity
            }&targetSize=${this.state.activeTestDriveCurrentActivityTargetSize ? this.state.activeTestDriveCurrentActivityTargetSize : DEFAULT_TARGET_SIZE
            }&targetType=${this.state.activeTestDriveCurrentActivityTargetType ? this.state.activeTestDriveCurrentActivityTargetType : DEFAULT_TARGET_TYPE}`
          );
        case TEST_DRIVE_ACTIVITIES.SWITCH_BASIC:
          return (
            `${window.location.origin
            }/test-drive/try/do/text-entry?activityType=${
            this.state.activeTestDrive.activeTestDriveCurrentActivity
            }&promptType=${this.state.activeTestDriveCurrentActivityPromptType ? this.state.activeTestDriveCurrentActivityPromptType : DEFAULT_TARGET_TYPE}`
          );
        default:
          return null;
      }
    }else{
      return (
        `${window.location.origin
        }/test-drive/try/do?clinicianId=${
          this.state.provider ? this.state.provider.id : this.props.provider ? this.props.provider.id : ''
        }&testDriveTaskId=${this.props.activeTestDriveActivityId}`);
    }
  }

  //On Continue for a given step:
  // figure out the next step and go to it
  // and if we're totally done with this section, submit the data.
  async onContinue(clickEvent, runningPractice) {
    let history = this.props.history;
    let nextStep = '';
    let nextRoute = '';
    let goToNextSection = false;
    let goBack = false;
    const curURL = new URL(window.location.href);

    switch(this.getCurrentStep()){
      case steps.ACTIVITY:
        nextStep = steps.START;  
        //having selected an activity, create an id for that activity IF:
        //there currently isn't an id, OR the last activity you did actually has data in it (we don't want to write over its activity type and name)  
        if(!this.props.activeTestDriveActivityId){
          this.props.updateSession('activeTrialTaskId', uuid(), () => {
            this.setState({
              'testDriveUrl' : this.getRemoteUrl()
            });
          });
          // await this.setActivityFinished(false); //ensure we don't end up creating another new id when going from /start to /do
        }else if(this.state.activeTestDrive.activeTestDriveCurrentActivityComplete){
          await this.resetActivityState(true)
        }else{
          this.setState({
            'testDriveUrl' : this.getRemoteUrl()
          });
        }
        break; 
      case steps.START:
        nextStep = steps.DO;
        //WHEN WOULD THIS BE TRUE???? -
        // 1. do a Text Entry activity, and see the results on /do
        // 2. Hit back button to return to /start, then Continue. At that point, builtInActivityComplete === true.
        // 3. Desired behavior is to make sure the Text Entry activity is saved, then start a second one.
        // Also occurs when you hit the Try It section tab after completing an activity. 
        if(this.state.activeTestDrive.activeTestDriveCurrentActivityComplete){
          // await this.saveActivitiesToSession(); //no longer need since we now save the previous activity before you get to this point.
          //this will also create a new task id
          await this.resetActivityState(false);
        }
        //this makes sure we see the activity test view (not the results view)
        await this.setActivityFinished(false); //might be redundant
        break;
      case steps.DO:
        //Note that we handle routing for the practice mode differently:
        // if we have just run a Practice test, just goBack (to /start), rather than push /start onto the history stack.
        // this avoids the Back button from /start popping you back to another Practice on /do
        if(this.state.runningPractice){
          goBack = true;
        }
        //built-in activities show the results on the /do route immediately after completing the trials, (the /do route saves the activity results)
        //otw Continue moves on
        else if (isBuiltInActivity(this.state.activeTestDrive.activeTestDriveCurrentActivity)){
          if( this.state.activeTestDrive.activeTestDriveCurrentActivityComplete){
            nextStep = steps.ANOTHER;
          }
          else{
            await this.setActivityFinished(true);
            nextStep = steps.DO;
          }
        }
        //for non built-in activities, save the activity and move on
        else{
          await this.setActivityFinished(true);
          await this.addActivityToActivities();
          nextStep = steps.ANOTHER;
        }
        break;
      case steps.ANOTHER:
        if(this.state.doAnotherActivity === 'true'){
          nextStep = steps.ACTIVITY;
        }
        else{
          nextStep = steps.UPDATE;
        }
        // await this.saveActivitiesToSession();
        await this.resetActivityState(true);
        break;
      case steps.UPDATE:
        nextStep = '';
        goToNextSection = true;
        break;
      default:
        console.log("   default next step");
        nextStep = steps.ACTIVITY;
    }
    if (!goToNextSection) {
      nextRoute = BASE_URL + nextStep;
    } 
    else {
      // alert("Done with this section. Data saved are: " + JSON.stringify(this.state));
      nextRoute = NEXT_SECTION;
    }

    // runningPractice could be undefined (e.g., if just calling onContinue()), so double negate to make sure is boolean
    this.setState({'runningPractice': !!runningPractice}, () => {
      this.setState({
        testDriveUrl: this.getRemoteUrl()
      });
    }); 

    if(goBack){   
      console.log("    going back from onContinue"); 
      if(this.state.runningRemotePractice){
        this.setState({
          disableInput: true
        });
        this.props.updateSession('returnToOtherComputer', true);            
      }else{
        history.goBack();
      }
    }else{
      history.push({
        pathname: nextRoute,
        search: curURL.search
      });
    }
  }

  //Adds the current activity in local state to the local activeTestDriveActivities
  //4-22-2025: modified to also save the activities array to global session (to reduce reliance on magic path, and reduce chance of data loss)
  async addActivityToActivities(){
    if(!this.props.activeTestDriveActivityId){
      return;
    }
    let curActivity = this.state.activeTestDriveActivities.find(a => a.id === this.props.activeTestDriveActivityId);
    if(curActivity){
      curActivity.type = this.state.activeTestDrive.activeTestDriveCurrentActivity;
      curActivity.name = this.state.activeTestDrive.activeTestDriveCurrentActivityName;
      // curActivity.numTexts = this.state.activeTestDrive.activeTestDriveCurrentActivityNumTexts;
      //keep the local state for settings flat (not part of activeTestDrive, to avoid collisions)
      curActivity.numTexts = this.state.activeTestDriveCurrentActivityNumTexts;
      curActivity.language = this.state.activeTestDriveCurrentActivityLanguage;
      curActivity.textUnit = this.state.activeTestDriveCurrentActivityTextUnit;
      curActivity.numTargets = this.state.activeTestDriveCurrentActivityNumTargets;
      curActivity.targetSize = this.state.activeTestDriveCurrentActivityTargetSize;
      curActivity.targetType = this.state.activeTestDriveCurrentActivityTargetType;
      curActivity.numPrompts = this.state.activeTestDriveCurrentActivityNumPrompts;
      curActivity.promptType = this.state.activeTestDriveCurrentActivityPromptType;

      curActivity.notes = this.state.activeTestDrive.activeTestDriveCurrentActivityNotes;
      curActivity.duration = this.state.activeTestDrive.activeTestDriveCurrentActivityDuration;
      curActivity.rawwpm = this.state.activeTestDrive.activeTestDriveCurrentActivityRawWPM;
      curActivity.wpm = this.state.activeTestDrive.activeTestDriveCurrentActivityWPM;
      curActivity.targetsPerMinute = this.state.activeTestDrive.activeTestDriveCurrentActivityTargetsPerMinute;
      curActivity.accuracy = this.state.activeTestDrive.activeTestDriveCurrentActivityAccuracy;
      curActivity.extraActivations = this.state.activeTestDrive.activeTestDriveCurrentActivityExtraActivations;
      curActivity.difficulty = this.state.activeTestDrive.activeTestDriveCurrentActivityDifficulty;
      curActivity.components = this.state.activeTestDrive.activeTestDriveCurrentActivityComponentStats;

      await new Promise(resolve => {
        this.setState((prevState) => {
          return{
            activeTestDriveActivities: prevState.activeTestDriveActivities.map(a => a.id === curActivity.id ? curActivity : a)
          };
        }, resolve);
      });
      await this.saveActivitiesToSession();
    }
    else{
      const activityToAdd = {};
      activityToAdd.id = this.props.activeTestDriveActivityId;
      activityToAdd.type = this.state.activeTestDrive.activeTestDriveCurrentActivity;
      activityToAdd.name = this.state.activeTestDrive.activeTestDriveCurrentActivityName;

      //Settings are stored FLAT in local state, rather than inside activeTestDrive 
      //(otw in saveCurrentActivity, we can't properly set their default values)
      // activityToAdd.numTexts = this.state.activeTestDrive.activeTestDriveCurrentActivityNumTexts;
      activityToAdd.numTexts = this.state.activeTestDriveCurrentActivityNumTexts;
      activityToAdd.language = this.state.activeTestDriveCurrentActivityLanguage;
      activityToAdd.textUnit = this.state.activeTestDriveCurrentActivityTextUnit;
      activityToAdd.numTargets = this.state.activeTestDriveCurrentActivityNumTargets;
      activityToAdd.targetSize = this.state.activeTestDriveCurrentActivityTargetSize;
      activityToAdd.targetType = this.state.activeTestDriveCurrentActivityTargetType;
      activityToAdd.numPrompts = this.state.activeTestDriveCurrentActivityNumPrompts;
      activityToAdd.promptType = this.state.activeTestDriveCurrentActivityPromptType;

      activityToAdd.notes = this.state.activeTestDrive.activeTestDriveCurrentActivityNotes;
      activityToAdd.duration = this.state.activeTestDrive.activeTestDriveCurrentActivityDuration;
      activityToAdd.rawwpm = this.state.activeTestDrive.activeTestDriveCurrentActivityRawWPM;
      activityToAdd.wpm = this.state.activeTestDrive.activeTestDriveCurrentActivityWPM;
      activityToAdd.targetsPerMinute = this.state.activeTestDrive.activeTestDriveCurrentActivityTargetsPerMinute;
      activityToAdd.accuracy = this.state.activeTestDrive.activeTestDriveCurrentActivityAccuracy;
      activityToAdd.extraActivations = this.state.activeTestDrive.activeTestDriveCurrentActivityExtraActivations;
      activityToAdd.difficulty = this.state.activeTestDrive.activeTestDriveCurrentActivityDifficulty;
      activityToAdd.components = this.state.activeTestDrive.activeTestDriveCurrentActivityComponentStats;

      await new Promise(resolve => {
        this.setState((prevState) => {
          const newTestDriveActivityList = prevState.activeTestDriveActivities.concat(activityToAdd);
          return{
            activeTestDriveActivities: newTestDriveActivityList
          };
        }, resolve);
      });
      await this.saveActivitiesToSession();
    }
  }

  //saves the array of activities to session. Called in onContinue under certain conditions.
  saveActivitiesToSession = async () => {
    console.log("saveActivitiesToSession");
    this.props.updateActiveTestDriveId();
    let newActiveTestDrive = {
      ...this.state.activeTestDrive,
      activeTestDriveActivities: this.state.activeTestDriveActivities,
    }
    await new Promise((resolve) => {
      this.props.updateSession('activeTestDrive', newActiveTestDrive, resolve );
    });
  }


  setReturnToOtherComputer = async () => { 
    this.setState({
      disableInput: true
    });
    this.props.updateSession('returnToOtherComputer', true);            
    await this.saveActivitiesToSession();
  }

  //reset the relevant pieces of state when starting a new activity
  async resetActivityState(resetSettings){
    var prevState = this.state;
    await new Promise((resolve) => {
      this.setState({
        'doAnotherActivity' : '',
        'builtInActivityComplete': false,
        activeTestDrive: {
          ...this.state.activeTestDrive,
        'activeTestDriveCurrentActivityName' : '',
        'activeTestDriveCurrentActivityNotes' : '',
        'activeTestDriveCurrentActivityDuration' : '',
        'activeTestDriveCurrentActivityRawWPM' : '',
        'activeTestDriveCurrentActivityWPM' : '',
        'activeTestDriveCurrentActivityTargetsPerMinute' : '',
        'activeTestDriveCurrentActivityAccuracy' : '',
        'activeTestDriveCurrentActivityExtraActivations': '',
        'activeTestDriveCurrentActivityDifficulty': '',
        'activeTestDriveCurrentActivityComponentStats' : [],
        'activeTestDriveCurrentActivityComplete' : false,      
        'activeTestDriveCurrentActivity' : '',
        'activeTestDriveCurrentActivityNumTexts' : ('' + DEFAULT_TEXTS_IN_TEST),
        'activeTestDriveCurrentActivityLanguage' : DEFAULT_TEXT_LANGUAGE,
        'activeTestDriveCurrentActivityTextUnit' : DEFAULT_TEXT_UNIT,
        'activeTestDriveCurrentActivityNumTargets' : ('' + DEFAULT_TARGETS_IN_TEST),
        'activeTestDriveCurrentActivityTargetSize' : ('' + DEFAULT_TARGET_SIZE),
        'activeTestDriveCurrentActivityTargetType' : DEFAULT_TARGET_TYPE,
        'activeTestDriveCurrentActivityNumPrompts' : ('' + DEFAULT_HITS_IN_TEST),
        'activeTestDriveCurrentActivityPromptType' : DEFAULT_TARGET_TYPE,
      }}, () => {
        this.props.updateSession('activeTestDrive', this.state.activeTestDrive, () => {
          if(resetSettings){
            console.log("@@@@@@ resetting activity id after setState");
  
            this.props.updateSession('activeTrialTaskId', '', resolve);
          }
          //WHEN WOULD THIS BE USED???? -
          // 1. do a Text Entry activity, and see the results on /do
          // 2. Hit back button to return to /start, then Continue. At that point, builtInActivityComplete === true.
          // 3. Desired behavior is to make sure the Text Entry activity is saved, then start a second one.
          // 
          else{
            this.props.updateSession('activeTrialTaskId', uuid(), () => {
              this.setState({
                activeTestDrive: {
                  ...this.state.activeTestDrive,      
                'activeTestDriveCurrentActivity' : prevState.activeTestDrive.activeTestDriveCurrentActivity,
                'activeTestDriveCurrentActivityName' : prevState.activeTestDrive.activeTestDriveCurrentActivityName,
                'activeTestDriveCurrentActivityNumTexts' : prevState.activeTestDrive.activeTestDriveCurrentActivityNumTexts,
                'activeTestDriveCurrentActivityLanguage' : prevState.activeTestDrive.activeTestDriveCurrentActivityLanguage,
                'activeTestDriveCurrentActivityTextUnit' : prevState.activeTestDrive.activeTestDriveCurrentActivityTextUnit,
                'activeTestDriveCurrentActivityNumTargets' : prevState.activeTestDrive.activeTestDriveCurrentActivityNumTargets,
                'activeTestDriveCurrentActivityTargetSize' : prevState.activeTestDrive.activeTestDriveCurrentActivityTargetSize,
                'activeTestDriveCurrentActivityTargetType' : prevState.activeTestDrive.activeTestDriveCurrentActivityTargetType,
                'activeTestDriveCurrentActivityNumPrompts' : prevState.activeTestDrive.activeTestDriveCurrentActivityNumPrompts,
                'activeTestDriveCurrentActivityPromptType' : prevState.activeTestDrive.activeTestDriveCurrentActivityPromptType,
              },
              'testDriveUrl' : this.getRemoteUrl()
            }, async () => {
                //TODO check this for a race condition...
                await this.saveActiveTestDriveCurrentActivityToSession();
                await this.saveActivitySettingsToSession();
                resolve();
              });
            });
          }
        });
      });
    });
  }

  // methods passed in to child routes to save data.
  // each one also checks to see if we need to create a new test-drive id

  async saveActiveTestDriveCurrentActivityToSession(){
    this.props.updateActiveTestDriveId();

    switch(this.state.activeTestDrive.activeTestDriveCurrentActivity){
      case TEST_DRIVE_ACTIVITIES.TEXT_ENTRY_BASIC:
        //if there is no value for a setting, set it to default (ensures that UI will show default values in /start route)
        if(!this.state.activeTestDriveCurrentActivityNumTexts)
          await this.updateActiveTestDriveInState('activeTestDriveCurrentActivityNumTexts', ('' + DEFAULT_TEXTS_IN_TEST));
        if(!this.state.activeTestDriveCurrentActivityLanguage)
          await this.updateActiveTestDriveInState('activeTestDriveCurrentActivityLanguage', ('' + DEFAULT_TEXT_LANGUAGE));
        if(!this.state.activeTestDrive.activeTestDriveCurrentActivityTextUnit)
          await this.updateActiveTestDriveInState('activeTestDriveCurrentActivityTextUnit', DEFAULT_TEXT_UNIT);
        break;
      case TEST_DRIVE_ACTIVITIES.POINTING_BASIC:
        if(!this.state.activeTestDriveCurrentActivityNumTargets)
          await this.updateActiveTestDriveInState('activeTestDriveCurrentActivityNumTargets', ('' + DEFAULT_TARGETS_IN_TEST));
        if(!this.state.activeTestDriveCurrentActivityTargetSize)
          await this.updateActiveTestDriveInState('activeTestDriveCurrentActivityTargetSize', ('' + DEFAULT_TARGET_SIZE));
        if(!this.state.activeTestDriveCurrentActivityTargetType)
          await this.updateActiveTestDriveInState('activeTestDriveCurrentActivityTargetType', DEFAULT_TARGET_TYPE);
        break;
      case TEST_DRIVE_ACTIVITIES.SWITCH_BASIC:
        if(!this.state.activeTestDriveCurrentActivityNumPrompts)
          await this.updateActiveTestDriveInState('activeTestDriveCurrentActivityNumPrompts', ('' + DEFAULT_HITS_IN_TEST));
        if(!this.state.activeTestDriveCurrentActivityPromptType)
          await this.updateActiveTestDriveInState('activeTestDriveCurrentActivityPromptType', DEFAULT_TARGET_TYPE);
        break;
      default:
        break;
    }

    let newActiveTestDrive = {
      ...this.state.activeTestDrive,
      activeTestDriveCurrentActivity: this.state.activeTestDrive.activeTestDriveCurrentActivity,
      activeTestDriveCurrentActivityName: this.state.activeTestDrive.activeTestDriveCurrentActivityName,
    };
    
    await new Promise(resolve => {
      this.props.updateSession('activeTestDrive', newActiveTestDrive, resolve);
    });
  }

  async updateActiveTestDriveInState(key, value){
    await new Promise(resolve => {
      this.setState({
        activeTestDrive: {
          ...this.state.activeTestDrive,
          [key]: value
        }
      }, resolve);
    });
  }

  async saveSetupInfoToSession(){
    this.props.updateActiveTestDriveId();
    //why not access mehtod and selection method?
    //actually the only ones who need it here may be the ones with text fields to fill in (comments and notes)
    let newActiveTestDrive = {
      ...this.state.activeTestDrive,
      activeSetupBodySite: this.state.activeTestDrive.activeSetupBodySite,
      activeSetupBodySiteComments: this.state.activeTestDrive.activeSetupBodySiteComments,
      activeSetupAccessories: this.state.activeTestDrive.activeSetupAccessories,
      activeSetupPositioningNotes: this.state.activeTestDrive.activeSetupPositioningNotes,
      activeSetupOtherNotes: this.state.activeTestDrive.activeSetupOtherNotes,
      activeSetupName: this.state.activeTestDrive.activeSetupName,
    }
    await new Promise((resolve) => {
      this.props.updateSession('activeTestDrive', newActiveTestDrive, resolve);
    });
  }

  async saveActivitySettingsToSession(){
    this.props.updateActiveTestDriveId();

    let newActiveTestDrive = {
      ...this.state.activeTestDrive,
    };

    switch(this.state.activeTestDrive.activeTestDriveCurrentActivity){
      case TEST_DRIVE_ACTIVITIES.TEXT_ENTRY_BASIC:
        newActiveTestDrive = {
          ...this.state.activeTestDrive,
          // activeTestDriveCurrentActivityNumTexts: this.state.activeTestDrive.activeTestDriveCurrentActivityNumTexts,
          activeTestDriveCurrentActivityNumTexts: this.state.activeTestDriveCurrentActivityNumTexts || ('' + DEFAULT_TEXTS_IN_TEST),
          activeTestDriveCurrentActivityLanguage: this.state.activeTestDriveCurrentActivityLanguage || ('' + DEFAULT_TEXT_LANGUAGE),
          activeTestDriveCurrentActivityTextUnit: this.state.activeTestDriveCurrentActivityTextUnit || DEFAULT_TEXT_UNIT,
        };
            break;
      case TEST_DRIVE_ACTIVITIES.POINTING_BASIC:
         newActiveTestDrive = {
          ...this.state.activeTestDrive,
          activeTestDriveCurrentActivityNumTargets: this.state.activeTestDriveCurrentActivityNumTargets || ('' + DEFAULT_TARGETS_IN_TEST),
          activeTestDriveCurrentActivityTargetSize: this.state.activeTestDriveCurrentActivityTargetSize || ('' + DEFAULT_TARGET_SIZE),
          activeTestDriveCurrentActivityPromptType: this.state.activeTestDriveCurrentActivityPromptType || DEFAULT_TARGET_TYPE
        };
            break;
      case TEST_DRIVE_ACTIVITIES.SWITCH_BASIC:
        newActiveTestDrive = {
          ...this.state.activeTestDrive,
          activeTestDriveCurrentActivityNumPrompts: this.state.activeTestDriveCurrentActivityNumPrompts || ('' + DEFAULT_HITS_IN_TEST),
          activeTestDriveCurrentActivityPromptType: this.state.activeTestDriveCurrentActivityPromptType || DEFAULT_TARGET_TYPE
        };
            break;
      default:
        break;
    }

    //Add other activity settings here when ready

    await new Promise((resolve) => {
      this.props.updateSession('activeTestDrive', newActiveTestDrive, resolve);
    });
  }

  
  saveActivityResultsToSession(){
    this.props.updateActiveTestDriveId();
    let newActiveTestDrive = {...this.state.activeTestDrive};

    switch(this.state.activeTestDrive.activeTestDriveCurrentActivity){
      case TEST_DRIVE_ACTIVITIES.TEXT_ENTRY_BASIC:
        newActiveTestDrive = {
          ...this.state.activeTestDrive,
          activeTestDriveCurrentActivityNotes: this.state.activeTestDrive.activeTestDriveCurrentActivityNotes,
          activeTestDriveCurrentActivityDuration: this.state.activeTestDrive.activeTestDriveCurrentActivityDuration,
          activeTestDriveCurrentActivityRawWPM: this.state.activeTestDrive.activeTestDriveCurrentActivityRawWPM,
          activeTestDriveCurrentActivityWPM: this.state.activeTestDrive.activeTestDriveCurrentActivityWPM,
          activeTestDriveCurrentActivityAccuracy: this.state.activeTestDrive.activeTestDriveCurrentActivityAccuracy,
          activeTestDriveCurrentActivityComponentStats: this.state.activeTestDrive.activeTestDriveCurrentActivityComponentStats,
        };    
        break;
      case TEST_DRIVE_ACTIVITIES.POINTING_BASIC:
        newActiveTestDrive = {
          ...this.state.activeTestDrive,
          activeTestDriveCurrentActivityNotes: this.state.activeTestDrive.activeTestDriveCurrentActivityNotes,
          activeTestDriveCurrentActivityDuration: this.state.activeTestDrive.activeTestDriveCurrentActivityDuration,
          activeTestDriveCurrentActivityTargetsPerMinute: this.state.activeTestDrive.activeTestDriveCurrentActivityTargetsPerMinute,
          activeTestDriveCurrentActivityAccuracy: this.state.activeTestDrive.activeTestDriveCurrentActivityAccuracy,
          activeTestDriveCurrentActivityComponentStats: this.state.activeTestDrive.activeTestDriveCurrentActivityComponentStats,
        };    
        break;
      case TEST_DRIVE_ACTIVITIES.SWITCH_BASIC:
        newActiveTestDrive = {
          ...this.state.activeTestDrive,
          activeTestDriveCurrentActivityNotes: this.state.activeTestDrive.activeTestDriveCurrentActivityNotes,
          activeTestDriveCurrentActivityDuration: this.state.activeTestDrive.activeTestDriveCurrentActivityDuration,
          activeTestDriveCurrentActivityExtraActivations: this.state.activeTestDrive.activeTestDriveCurrentActivityExtraActivations,
          activeTestDriveCurrentActivityDifficulty: this.state.activeTestDrive.activeTestDriveCurrentActivityDifficulty,
          activeTestDriveCurrentActivityComponentStats: this.state.activeTestDrive.activeTestDriveCurrentActivityComponentStats,
        };    
        break;
      default:
        break;
    }
    //save the activeTestDrive, only if this is a built-in activity, once the results are in. 
    // (Your own activity gets saved onContinue, and if saved here it creates a race condition with addActivityToActivities())
    if(isBuiltInActivity(this.state.activeTestDrive.activeTestDriveCurrentActivity)){
      this.props.updateSession('activeTestDrive', newActiveTestDrive);
    }
  }

  //** Note that this calls onContinue to handle the case where we are returning automatically from completing a Practice activity
  saveActivityResultsToLocalState(resultsObj){
    if(this.state.runningPractice){
      this.onContinue(undefined, false);
    }else{
      if(resultsObj.type === TEST_DRIVE_ACTIVITIES.TEXT_ENTRY_BASIC){
        this.setState({
          builtInActivityComplete: true,
          activeTestDrive: {
            ...this.state.activeTestDrive,
            activeTestDriveCurrentActivityComplete:true,
            activeTestDriveCurrentActivityDuration:resultsObj.averageDuration,
            activeTestDriveCurrentActivityRawWPM: resultsObj.averageRawWPM,
            activeTestDriveCurrentActivityWPM: resultsObj.averageCorrectWPM,
            activeTestDriveCurrentActivityAccuracy: resultsObj.averageAccuracy,
            activeTestDriveCurrentActivityComponentStats: resultsObj.completedTests
          }
        },async () => {
          await this.addActivityToActivities();
          if(this.state.runningRemoteTestDrive){
            await this.setReturnToOtherComputer();            
          }  
        });
      }
      else if(resultsObj.type === TEST_DRIVE_ACTIVITIES.POINTING_BASIC){
        this.setState({
          builtInActivityComplete: true,
          activeTestDrive: {
            ...this.state.activeTestDrive,
            activeTestDriveCurrentActivityComplete:true,
            activeTestDriveCurrentActivityDuration:resultsObj.averageDuration,
            activeTestDriveCurrentActivityTargetsPerMinute: resultsObj.targetsPerMinute,
            activeTestDriveCurrentActivityAccuracy: resultsObj.averageAccuracy,
            activeTestDriveCurrentActivityComponentStats: resultsObj.completedTests
         }
        },async () => {
          await this.addActivityToActivities();
          if(this.state.runningRemoteTestDrive){
            await this.setReturnToOtherComputer();            
          }
          });
      }else if(resultsObj.type === TEST_DRIVE_ACTIVITIES.SWITCH_BASIC){
        this.setState({
          builtInActivityComplete: true,
          activeTestDrive: {
            ...this.state.activeTestDrive,
            activeTestDriveCurrentActivityComplete:true,
            activeTestDriveCurrentActivityDuration: resultsObj.averageTrialTime,
            activeTestDriveCurrentActivityExtraActivations: resultsObj.averageExtraActivations,
            activeTestDriveCurrentActivityDifficulty: resultsObj.switchDifficulty,
            activeTestDriveCurrentActivityComponentStats: resultsObj.completedTests
          }
        },async () => {
          await this.addActivityToActivities();
          if(this.state.runningRemoteTestDrive){
            await this.setReturnToOtherComputer();            
          }
          });
      }
    }
  }

  //** Note that this calls onContinue to handle the End Activity button when running a Practice activity */
  async setActivityFinished(value){
    if(this.state.runningPractice && value){
      if(this.state.runningRemotePractice){
        this.setState({
          disableInput: true
        });
        this.props.updateSession('returnToOtherComputer', true);            
      }else{
        this.onContinue();
      }
    }
    else
      // MERGE TODO
      // this.setState({'builtInActivityComplete': value});
      await new Promise(resolve => {
      this.setState({
        activeTestDrive: {
          ...this.state.activeTestDrive,
          activeTestDriveCurrentActivityComplete:value,
        }
      }, resolve);
    });
  }

  setShowSettings(value){
    this.setState({'showSettings': value});
  }

  //the keys are the names of the local state variables, defined above in the constructor
  updateLocalState(key) {
    return evt => {
      const target = evt.target; /* which input has been changed */
      let value = target.type === 'checkbox' ? target.checked: target.value;
      console.log("Updating TestDriveTry local state with key: " + key + " value: " + value);

      //set doAnotherActivity directly (it's not part of the activeTestDrive)
      if(this.isFlatKey(key)){ //(key === 'doAnotherActivity') || (key === 'activeTestDriveCurrentActivityNumTexts')){
        console.log("**** setting flat state: " + key + " to: " + value);
        this.setState({[key]: value});
      }
      //after you click on an activity button, manage the displayable activity name
      else if(key === 'activeTestDriveCurrentActivity'){
        let aName = ''; //make sure name is empty if you chose 'your own activity'
        if (value !== 'own-activity'){
          aName = getActivityLabelForValue(value);
        }
        this.setState({
          activeTestDrive: {
            ...this.state.activeTestDrive,
            [key]: value,
            activeTestDriveCurrentActivityName: aName
          }
        });
      }
      else{
        this.setState({
          activeTestDrive: {
            ...this.state.activeTestDrive,
            [key]: value
          }
        });
      }
    }
  }

  isFlatKey(key){
    const flatKeys = [
      'doAnotherActivity',
      'runOnSameComputer',
      'activeTestDriveCurrentActivityNumTexts',
      'activeTestDriveCurrentActivityLanguage',
      'activeTestDriveCurrentActivityTextUnit',
      'activeTestDriveCurrentActivityNumTargets',
      'activeTestDriveCurrentActivityTargetSize',
      'activeTestDriveCurrentActivityTargetType',
      'activeTestDriveCurrentActivityNumPrompts',
      'activeTestDriveCurrentActivityPromptType'      
    ];
    return(flatKeys.includes(key));
  }

  //TODO ?? Will this play nice with the getDerivedStateFromProps hook above ??
  //Also includes activeSetup props, since those can be viewed in this section at /test-drive/try/update-setup
  //If new props come in after rendering, update the views in this tab.
  //(This occurs when you refresh a view and it pulls data from the database.)
  //TODO 4/21/25 -- not sure that this is necessary - cannot find a case where it does not refresh.
  componentDidUpdate(prevProps, prevState){
    //for values that are Objects:
    if (_.isEqual(this.props.activeTestDrive, prevProps.activeTestDrive) === false){
      console.log("--incoming activeTestDrive: " + this.props.activeTestDrive + " differ from prev activeTestDrive: " + prevProps.activeTestDrive);
      this.setState({'activeTestDrive': this.props.activeTestDrive});  
    
    };
    if(_.isEqual(this.props.provider, prevProps.provider) === false){
      console.log("--incoming props: " + this.props.provider + " differ from prev props: " + prevProps.provider);
      this.setState({
        'provider': this.props.provider,
      }, () => {
        this.setState({
          'testDriveUrl' : this.getRemoteUrl()
        });
      });
    }

    //for values that are Arrays:
    // if (_.isEqual(this.props.activeTestDriveActivities, prevProps.activeTestDriveActivities) === false){
    //   console.log("--incoming props: " + this.props.activeTestDriveActivities + " differ from prev props: " + prevProps.activeTestDriveActivities);
    //   this.setState({'activeTestDriveActivities': this.props.activeTestDriveActivities});
    // };

    // if (_.isEqual(this.props.activeSetupBodySite, prevProps.activeSetupBodySite) === false){
    //   console.log("--incoming props: " + this.props.activeSetupBodySite + " differ from prev props: " + prevProps.activeSetupBodySite);
    //   this.setState({'activeSetupBodySite': this.props.activeSetupBodySite});
    // };
    // if (_.isEqual(this.props.activeSetupAccessories, prevProps.activeSetupAccessories) === false){
    //   console.log("--incoming props: " + this.props.activeSetupAccessories + " differ from prev props: " + prevProps.activeSetupAccessories);
    //   this.setState({'activeSetupAccessories': this.props.activeSetupAccessories});
    // };

    // //for simple strings
    if(this.props.activeTestDriveActivityId !== prevProps.activeTestDriveActivityId){
      console.log("--incoming props: " + this.props.activeTestDriveActivityId + " differ from prev props: " + prevProps.activeTestDriveActivityId);
      this.setState({
        'activeTestDriveActivityId': this.props.activeTestDriveActivityId,
        'testDriveUrl' : this.getRemoteUrl()
      });
    }
  
    // if (this.props.activeTestDriveCurrentActivity !== prevProps.activeTestDriveCurrentActivity){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivity + " differ from prev props: " + prevProps.activeTestDriveCurrentActivity);
    //   this.setState({'activeTestDriveCurrentActivity': this.props.activeTestDriveCurrentActivity});
    // }
    // if (this.props.activeTestDriveCurrentActivityName !== prevProps.activeTestDriveCurrentActivityName){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityName + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityName);
    //   this.setState({'activeTestDriveCurrentActivityName': this.props.activeTestDriveCurrentActivityName});
    // }
    // if (this.props.activeTestDriveCurrentActivityNumTexts !== prevProps.activeTestDriveCurrentActivityNumTexts){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityNumTexts + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityNumTexts);
    //   this.setState({'activeTestDriveCurrentActivityNumTexts': this.props.activeTestDriveCurrentActivityNumTexts});
    // }
    // if (this.props.activeTestDriveCurrentActivityLanguage !== prevProps.activeTestDriveCurrentActivityLanguage){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityLanguage + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityLanguage);
    //   this.setState({'activeTestDriveCurrentActivityLanguage': this.props.activeTestDriveCurrentActivityLanguage});
    // }
    // if (this.props.activeTestDriveCurrentActivityTextUnit !== prevProps.activeTestDriveCurrentActivityTextUnit){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityTextUnit + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityTextUnit);
    //   this.setState({'activeTestDriveCurrentActivityTextUnit': this.props.activeTestDriveCurrentActivityTextUnit});
    // }
    // if (this.props.activeTestDriveCurrentActivityNumTargets !== prevProps.activeTestDriveCurrentActivityNumTargets){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityNumTargets + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityNumTargets);
    //   this.setState({'activeTestDriveCurrentActivityNumTargets': this.props.activeTestDriveCurrentActivityNumTargets});
    // }
    // if (this.props.activeTestDriveCurrentActivityTargetSize !== prevProps.activeTestDriveCurrentActivityTargetSize){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityTargetSize + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityTargetSize);
    //   this.setState({'activeTestDriveCurrentActivityTargetSize': this.props.activeTestDriveCurrentActivityTargetSize});
    // }
    // if (this.props.activeTestDriveCurrentActivityTargetType !== prevProps.activeTestDriveCurrentActivityTargetType){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityTargetType + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityTargetType);
    //   this.setState({'activeTestDriveCurrentActivityTargetType': this.props.activeTestDriveCurrentActivityTargetType});
    // }
    // if (this.props.activeTestDriveCurrentActivityNumPrompts !== prevProps.activeTestDriveCurrentActivityNumPrompts){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityNumPrompts + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityNumPrompts);
    //   this.setState({'activeTestDriveCurrentActivityNumPrompts': this.props.activeTestDriveCurrentActivityNumPrompts});
    // }
    // if (this.props.activeTestDriveCurrentActivityPromptType !== prevProps.activeTestDriveCurrentActivityPromptType){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityPromptType + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityPromptType);
    //   this.setState({'activeTestDriveCurrentActivityPromptType': this.props.activeTestDriveCurrentActivityPromptType});
    // }
    // if (this.props.activeTestDriveCurrentActivityNotes !== prevProps.activeTestDriveCurrentActivityNotes){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityNotes + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityNotes);
    //   this.setState({'activeTestDriveCurrentActivityNotes': this.props.activeTestDriveCurrentActivityNotes});
    // }
    // if (this.props.activeTestDriveCurrentActivityDuration !== prevProps.activeTestDriveCurrentActivityDuration){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityDuration + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityDuration);
    //   this.setState({'activeTestDriveCurrentActivityDuration': this.props.activeTestDriveCurrentActivityDuration});
    // }
    // if (this.props.activeTestDriveCurrentActivityRawWPM !== prevProps.activeTestDriveCurrentActivityRawWPM){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityRawWPM + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityRawWPM);
    //   this.setState({'activeTestDriveCurrentActivityRawWPM': this.props.activeTestDriveCurrentActivityRawWPM});
    // }
    // if (this.props.activeTestDriveCurrentActivityWPM !== prevProps.activeTestDriveCurrentActivityWPM){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityWPM + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityWPM);
    //   this.setState({'activeTestDriveCurrentActivityWPM': this.props.activeTestDriveCurrentActivityWPM});
    // }
    // if (this.props.activeTestDriveCurrentActivityTargetsPerMinute !== prevProps.activeTestDriveCurrentActivityTargetsPerMinute){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityTargetsPerMinute + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityTargetsPerMinute);
    //   this.setState({'activeTestDriveCurrentActivityTargetsPerMinute': this.props.activeTestDriveCurrentActivityTargetsPerMinute});
    // }
    // if (this.props.activeTestDriveCurrentActivityAccuracy !== prevProps.activeTestDriveCurrentActivityAccuracy){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityAccuracy + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityAccuracy);
    //   this.setState({'activeTestDriveCurrentActivityAccuracy': this.props.activeTestDriveCurrentActivityAccuracy});
    // }
    // if (this.props.activeTestDriveCurrentActivityExtraActivations !== prevProps.activeTestDriveCurrentActivityExtraActivations){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityExtraActivations + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityExtraActivations);
    //   this.setState({'activeTestDriveCurrentActivityExtraActivations': this.props.activeTestDriveCurrentActivityExtraActivations});
    // }    
    // if (this.props.activeTestDriveCurrentActivityDifficulty !== prevProps.activeTestDriveCurrentActivityDifficulty){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityDifficulty + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityDifficulty);
    //   this.setState({'activeTestDriveCurrentActivityDifficulty': this.props.activeTestDriveCurrentActivityDifficulty});
    // }
    // if (this.props.activeTestDriveCurrentActivityComponentStats !== prevProps.activeTestDriveCurrentActivityComponentStats){
    //   console.log("--incoming props: " + this.props.activeTestDriveCurrentActivityComponentStats + " differ from prev props: " + prevProps.activeTestDriveCurrentActivityComponentStats);
    //   this.setState({'activeTestDriveCurrentActivityComponentStats': this.props.activeTestDriveCurrentActivityComponentStats});
    // }
    // if (this.props.activeSetupSelectionMethod !== prevProps.activeSetupSelectionMethod){
    //   console.log("--incoming props: " + this.props.activeSetupSelectionMethod + " differ from prev props: " + prevProps.activeSetupSelectionMethod);
    //   this.setState({'activeSetupSelectionMethod': this.props.activeSetupSelectionMethod});
    // }
    // if (this.props.activeSetupBodySiteComments !== prevProps.activeSetupBodySiteComments){
    //     console.log("--incoming props: " + this.props.activeSetupBodySiteComments + " differ from prev props: " + prevProps.activeSetupBodySiteComments);
    //     this.setState({'activeSetupBodySiteComments': this.props.activeSetupBodySiteComments});
    // }
    // if (this.props.activeSetupPositioningNotes !== prevProps.activeSetupPositioningNotes){
    //   console.log("--incoming props: " + this.props.activeSetupPositioningNotes + " differ from prev props: " + prevProps.activeSetupPositioningNotes);
    //   this.setState({'activeSetupPositioningNotes': this.props.activeSetupPositioningNotes});
    // }
    // if (this.props.activeSetupOtherNotes !== prevProps.activeSetupOtherNotes){
    //   console.log("--incoming props: " + this.props.activeSetupOtherNotes + " differ from prev props: " + prevProps.activeSetupOtherNotes);
    //   this.setState({'activeSetupOtherNotes': this.props.activeSetupOtherNotes});
    // }
    // if (this.props.activeSetupName !== prevProps.activeSetupName){
    //   console.log("--incoming props: " + this.props.activeSetupName + " differ from prev props: " + prevProps.activeSetupName);
    //   this.setState({'activeSetupName': this.props.activeSetupName});
    // }

    if(this.getCurrentStep() === steps.ACTIVITY && this.state.activeTestDrive.activeTestDriveCurrentActivityComplete){
      this.resetActivityState(true);
      // this.setActivityFinished(false); //ensure we don't end up creating another new id when going from /start to /do
    }
  }

  //TODO this has a separate route for N steps of running the activity.
  //This works but makes for some clunky navigation if you try to move around outside of the normal workflow.
  //Might it be better to have one route that displays 1 of N components depending on whether
  //the activity is pending/inProgress/complete?
  //https://stackoverflow.com/questions/42474176/using-conditional-component-with-the-same-route-path-in-reactjs
  render() {
    console.log("rendering TestDriveTry, with activity type: " + JSON.stringify(this.state.activeTestDrive.activeTestDriveCurrentActivity) + 
    " and state.activeTestDrive: " + JSON.stringify(this.state.activeTestDrive) + " and props.activeTestDrive: " + JSON.stringify(this.props.activeTestDrive));
    const firstName = this.props.firstName;
    const pronouns = this.props.pronouns;
    const provider = this.props.provider;
    const isLowTechPath = this.props.isLowTechPath;
    const activeAccessMethodCategory = this.props.activeTestDrive.activeAccessMethodCategory;
    const activeTestDriveCurrentActivity = this.props.activeTestDrive.activeTestDriveCurrentActivity;
    const activeTestDriveCurrentActivityName = this.props.activeTestDrive.activeTestDriveCurrentActivityName;   
    const activeTestDriveCurrentActivityNumTexts = this.props.activeTestDrive.activeTestDriveCurrentActivityNumTexts; 
    const activeTestDriveCurrentActivityLanguage = this.props.activeTestDrive.activeTestDriveCurrentActivityLanguage; 
    const activeTestDriveCurrentActivityTextUnit = this.props.activeTestDrive.activeTestDriveCurrentActivityTextUnit; 
    const activeTestDriveCurrentActivityNumTargets = this.props.activeTestDrive.activeTestDriveCurrentActivityNumTargets; 
    const activeTestDriveCurrentActivityTargetSize = this.props.activeTestDrive.activeTestDriveCurrentActivityTargetSize; 
    const activeTestDriveCurrentActivityTargetType = this.props.activeTestDrive.activeTestDriveCurrentActivityTargetType; 
    const activeTestDriveCurrentActivityNumPrompts = this.props.activeTestDrive.activeTestDriveCurrentActivityNumPrompts; 
    const activeTestDriveCurrentActivityPromptType = this.props.activeTestDrive.activeTestDriveCurrentActivityPromptType; 
    const curURL = new URL(window.location.href);
    const searchQuery = curURL.search;
    const activeTestDriveCurrentActivityComponentStats = this.props.activeTestDrive.activeTestDriveCurrentActivityComponentStats;
    const dev = this.props.dev;

    let isLoggedIn = provider ? true : false;

    return(
    <>
    <Switch>
      <Route path={BASE_URL + steps.ACTIVITY}>
        <TestDriveTryActivity
          key={steps.ACTIVITY}
          firstName={firstName}
          activeAccessMethodCategory={activeAccessMethodCategory}
          isLowTechPath={isLowTechPath}
          onContinue={this.onContinue}
          activeTestDriveCurrentActivity={this.state.activeTestDrive.activeTestDriveCurrentActivity}
          onChangeActiveTestDriveCurrentActivity={this.updateLocalState("activeTestDriveCurrentActivity")}
          activeTestDriveCurrentActivityName={this.state.activeTestDrive.activeTestDriveCurrentActivityName}
          onChangeActiveTestDriveCurrentActivityName={this.updateLocalState("activeTestDriveCurrentActivityName")}
          saveFormData={this.saveActiveTestDriveCurrentActivityToSession}
          dev={dev}
        />
      </Route>
      <Route path={BASE_URL+ steps.START}>
        <TestDriveTryStart
          key={steps.START}
          firstName={firstName}
          pronouns={pronouns}
          activeTestDriveCurrentActivity={activeTestDriveCurrentActivity}
          activeTestDriveCurrentActivityName={activeTestDriveCurrentActivityName}
          activeTestDriveCurrentActivityNumTexts={this.state.activeTestDriveCurrentActivityNumTexts}
          onChangeActiveTestDriveCurrentActivityNumTexts={this.updateLocalState('activeTestDriveCurrentActivityNumTexts')}
          activeTestDriveCurrentActivityLanguage={this.state.activeTestDriveCurrentActivityLanguage}
          onChangeActiveTestDriveCurrentActivityLanguage={this.updateLocalState('activeTestDriveCurrentActivityLanguage')}
          activeTestDriveCurrentActivityTextUnit={this.state.activeTestDriveCurrentActivityTextUnit}
          onChangeActiveTestDriveCurrentActivityTextUnit={this.updateLocalState('activeTestDriveCurrentActivityTextUnit')}
          activeTestDriveCurrentActivityNumTargets={this.state.activeTestDriveCurrentActivityNumTargets}
          onChangeActiveTestDriveCurrentActivityNumTargets={this.updateLocalState('activeTestDriveCurrentActivityNumTargets')}
          activeTestDriveCurrentActivityTargetSize={this.state.activeTestDriveCurrentActivityTargetSize}
          onChangeActiveTestDriveCurrentActivityTargetSize={this.updateLocalState('activeTestDriveCurrentActivityTargetSize')}
          activeTestDriveCurrentActivityTargetType={this.state.activeTestDriveCurrentActivityTargetType}
          onChangeActiveTestDriveCurrentActivityTargetType={this.updateLocalState('activeTestDriveCurrentActivityTargetType')}
          activeTestDriveCurrentActivityNumPrompts={this.state.activeTestDriveCurrentActivityNumPrompts}
          onChangeActiveTestDriveCurrentActivityNumPrompts={this.updateLocalState('activeTestDriveCurrentActivityNumPrompts')}
          activeTestDriveCurrentActivityPromptType={this.state.activeTestDriveCurrentActivityPromptType}
          onChangeActiveTestDriveCurrentActivityPromptType={this.updateLocalState('activeTestDriveCurrentActivityPromptType')}
          runOnSameComputer={this.state.runOnSameComputer}
          onChangeRunOnSameComputer={this.updateLocalState('runOnSameComputer')}
          showSettings={this.state.showSettings}
          isLoggedIn={isLoggedIn}
          setShowSettings={this.setShowSettings}
          saveFormData={this.saveActivitySettingsToSession}
          onContinue={this.onContinue}
          dev={dev}
        />
      </Route>
      <Route path={BASE_URL+ steps.DO}>
        <TestDriveTryDo
          key={steps.DO}
          firstName={firstName}
          pronouns={pronouns}
          runOnSameComputer={this.state.runOnSameComputer}
          runningPractice={this.state.runningPractice}
          disableInput={this.state.disableInput}
          testDriveUrl={this.state.runningRemoteTestDrive || this.state.runningRemotePractice ? '' : this.state.testDriveUrl}
          activeTestDriveCurrentActivity={activeTestDriveCurrentActivity}
          activeTestDriveCurrentActivityNumTexts={activeTestDriveCurrentActivityNumTexts}
          activeTestDriveCurrentActivityLanguage={activeTestDriveCurrentActivityLanguage}
          activeTestDriveCurrentActivityTextUnit={activeTestDriveCurrentActivityTextUnit}
          activeTestDriveCurrentActivityNumTargets={activeTestDriveCurrentActivityNumTargets}
          activeTestDriveCurrentActivityTargetSize={activeTestDriveCurrentActivityTargetSize}
          activeTestDriveCurrentActivityTargetType={activeTestDriveCurrentActivityTargetType}
          activeTestDriveCurrentActivityNumPrompts={activeTestDriveCurrentActivityNumPrompts}
          activeTestDriveCurrentActivityPromptType={activeTestDriveCurrentActivityPromptType}
          activeTestDriveCurrentActivityComplete={this.state.activeTestDrive.activeTestDriveCurrentActivityComplete}
          onActiveTestDriveCurrentActivityComplete={this.setActivityFinished}
          activeTestDriveCurrentActivityName={activeTestDriveCurrentActivityName}
          activeTestDriveCurrentActivityComponentStats={activeTestDriveCurrentActivityComponentStats}
          activeTestDriveCurrentActivityNotes={this.state.activeTestDrive.activeTestDriveCurrentActivityNotes}
          onChangeActiveTestDriveCurrentActivityNotes={this.updateLocalState("activeTestDriveCurrentActivityNotes")}
          saveActivityResultsToLocalState={this.saveActivityResultsToLocalState}
          saveFormData={this.saveActivityResultsToSession}
          onContinue={this.onContinue}
          dev={dev}
        />
      </Route>
      <Route path={BASE_URL+ steps.UPDATE}>
        <TestDriveTryUpdate
          key={steps.UPDATE}
          activeAccessMethodName={this.state.activeTestDrive.activeAccessMethodName}
          activeSetupSelectionMethod={this.state.activeTestDrive.activeSetupSelectionMethod}
          activeSetupBodySite={this.state.activeTestDrive.activeSetupBodySite}
          activeSetupBodySiteComments={this.state.activeTestDrive.activeSetupBodySiteComments}
          activeSetupAccessories={this.state.activeTestDrive.activeSetupAccessories}
          activeSetupPositioningNotes={this.state.activeTestDrive.activeSetupPositioningNotes}
          activeSetupOtherNotes={this.state.activeTestDrive.activeSetupOtherNotes}
          activeSetupName={this.state.activeTestDrive.activeSetupName}
          onChangeActiveSetupBodySiteComments={this.updateLocalState("activeSetupBodySiteComments")}
          onChangeActiveSetupAccessories={this.updateLocalState("activeSetupAccessories")}
          onChangeActiveSetupPositioningNotes={this.updateLocalState("activeSetupPositioningNotes")}
          onChangeActiveSetupOtherNotes={this.updateLocalState("activeSetupOtherNotes")}
          onChangeActiveSetupName={this.updateLocalState("activeSetupName")}
          saveFormData={this.saveSetupInfoToSession}
          onContinue={this.onContinue}
          dev={dev}
        />
      </Route>
      <Route path={BASE_URL+ steps.ANOTHER}>
        <TestDriveTryAnother
          key={steps.ANOTHER}
          doAnotherActivity={this.state.doAnotherActivity}
          onChangeDoAnotherActivity={this.updateLocalState("doAnotherActivity")}
          onContinue={this.onContinue}
          dev={dev}
        />
      </Route>
      <Route path={BASE_URL}>
        <Redirect to={BASE_URL + steps.ACTIVITY + searchQuery} />
      </Route>
    </Switch>
    </>
    );
  }
}

TestDriveTry.propTypes = propTypes;
TestDriveTry.defaultProps = defaultProps;

// withRouter wrapper provides access to the match, location, and history props (used in onContinue)
export default withRouter(TestDriveTry);
